import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@material-ui/core';
import { Button, Typography } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../knock-design-system';
import { DIALOG_CARD_LABELS } from './constants';

const useCss = makeCss({
  dropCard: {
    boxSizing: 'border-box',
    cursor: 'pointer',
    height: '200px',
    width: '200px',
  },
  dropCardContent: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    height: '100%',
  },
  emptyDropCard: {
    textAlign: 'center',
  },
  errorMessage: {
    marginTop: '24px',
  },
  fullWidthDropCard: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  fullWidthDropCardContent: {
    width: '100%',
  },
});

const ImageDropCard = ({
  dropFrameRef,
  errorMessage,
  handleDropTargetClick,
  isFullWidthDropCard,
}) => {
  const css = useCss();

  if (isFullWidthDropCard) {
    return (
      <Card
        aria-label={DIALOG_CARD_LABELS.DROP_CARD_FULL_WIDTH}
        css={css.fullWidthDropCard}
        ref={dropFrameRef}
        elevation={0}
      >
        <CardContent css={css.fullWidthDropCardContent}>
          <div css={css.emptyDropCard}>
            <Typography
              align="center"
              color="text.tertiary"
              paragraph
              variant="body2"
            >
              Drag and drop images here
              <br />
              <br />
              or
            </Typography>

            <Button
              color="primary"
              onClick={handleDropTargetClick}
              startIcon="camera"
              variant="text"
            >
              Click to browse files
            </Button>
          </div>

          {errorMessage && (
            <Typography
              align="center"
              color="error.600"
              css={css.errorMessage}
              paragraph
              variant="body2"
            >
              {errorMessage}
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  }

  return (
    <Card
      aria-label={DIALOG_CARD_LABELS.DROP_CARD}
      css={css.dropCard}
      ref={dropFrameRef}
      variant="outlined"
    >
      <CardContent css={css.dropCardContent}>
        <Typography align="center" color="text.tertiary" variant="body2">
          Drag and drop photos or click here to browse...
        </Typography>
      </CardContent>
    </Card>
  );
};

ImageDropCard.propTypes = {
  dropFrameRef: PropTypes.object,
  errorMessage: PropTypes.string,
  handleDropTargetClick: PropTypes.func,
  isFullWidthDropCard: PropTypes.bool,
};

export default ImageDropCard;
